<template>
  <v-dialog v-model="show" max-width="648">
    <v-card>
      <v-card-title class="body-1">
        {{ event.Plate }} ({{ event.Confidence }}%)
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <img
          v-if="event && event.HasImage && !loading.state"
          :src="event.Image"
          style="width: 100%;"
        />
        <span v-if="!hasImage && !loading.state"> No image </span>
        <v-toolbar v-if="!event && loading.state" class="elevation-0">
          <v-spacer></v-spacer>
          <v-progress-circular
            indeterminate
            color="secondary"
          ></v-progress-circular>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LPREventImageDialog',
  props: {
    eventId: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      event: '',
      hasImage: false
    }
  },
  watch: {
    event(newValue) {
      if (newValue.HasImage) {
        this.hasImage = true
      } else {
        this.hasImage = false
      }
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.event = ''
          this.$emit('close')
        }
      }
    }
  },
  created() {
    this.$store.dispatch('sessions/getLPREvent', this.eventId).then(event => {
      this.event = event
    })
  }
}
</script>
